Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminListTypes = void 0;
var AdminListTypes = exports.AdminListTypes = function (AdminListTypes) {
  AdminListTypes["organizationTeams"] = "organizationTeams";
  AdminListTypes["organizationMembers"] = "organizationMembers";
  AdminListTypes["organizationPendingMembers"] = "organizationPendingMembers";
  AdminListTypes["teamMembers"] = "teamMembers";
  AdminListTypes["teamPendingMembers"] = "teamPendingMembers";
  return AdminListTypes;
}({});